import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

const Container = styled.div`
    display : flex;
    align-items :center;
    justify-content:center;
`;


const Message = styled.div`
    color: rgba(0, 0, 0, 0.77);
    font-family: Roboto;
    font-size: 30px;
    font-weight: 400;
    letter-spacing: 0.25px;
    line-height: 24px;
    text-align: left;
`;


function EmptyStateMessage(props) {

    const {width,height} = props.contentSize;

    return (
        <Container style={{width,height}}>
            <Message>
                {props.children}
            </Message>
        </Container>
    )
}

EmptyStateMessage.propTypes = {

}


const mapStateToProps = (state) => {
    return { 
        contentSize: state.app.contentSize 
    };
};

export default connect(mapStateToProps, { })(EmptyStateMessage);